import { render, staticRenderFns } from "./Roi.vue?vue&type=template&id=bc1dfd4c&scoped=true"
import script from "./Roi.vue?vue&type=script&lang=js"
export * from "./Roi.vue?vue&type=script&lang=js"
import style0 from "./Roi.vue?vue&type=style&index=0&id=bc1dfd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1dfd4c",
  null
  
)

export default component.exports